import { render, staticRenderFns } from "./AllShipments.vue?vue&type=template&id=1c3515ce&scoped=true&"
import script from "./AllShipments.vue?vue&type=script&lang=js&"
export * from "./AllShipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3515ce",
  null
  
)

export default component.exports